import React from 'react';
import { Icon, Reveal } from '@/components/ui';
import type { IconName } from '@/lib/icons';

interface OriginLocationProps {
    icon: IconName;
    title: string;
    description: string;
    /** Stagger delay (ms) for the scroll-reveal animation. */
    delay?: number;
}

const OriginLocation: React.FC<OriginLocationProps> = ({ icon, title, description, delay }) => {
    return (
        <Reveal as="div" className="origin-card card" delay={delay}>
            <Icon name={icon} />
            <h3>{title}</h3>
            <p>{description}</p>
        </Reveal>
    );
};

export default OriginLocation;
